import { createSlice } from 'utils/@reduxjs/toolkit';
import { ERPSystem, LanguageType } from 'app/features/erpSystem/slice/types';
import { ErpSystemState } from './types';
import { reducers } from './reducers';

import { LANGUAGE_ID_MAP } from '../constants';

const erpSystemFromUrl = window.location.hostname
  .split('.')
  .slice(-1)[0]
  .toUpperCase() as ERPSystem;
const languageFromUrl = window.location.pathname.split('/')[1] as LanguageType;

export const initialState: ErpSystemState = {
  erpSystem: erpSystemFromUrl,
  language: languageFromUrl,
  languageId: LANGUAGE_ID_MAP[languageFromUrl],
};

const slice = createSlice({
  name: 'erpSystem',
  initialState,
  reducers,
});

export const { actions: erpSystemActions } = slice;
export const { reducer: erpSystemReducer } = slice;
